import { LegalShell, Section, SUPPORT_EMAIL } from "@/components/LegalShell";

export default function Privacy() {
  return (
    <LegalShell
      title="Privacy Policy"
      subtitle="Your pay data is personal. This policy explains what we collect, why, and the choices you have."
      updated="June 2, 2026"
    >
      <div data-testid="privacy-content" className="space-y-8">
        <Section heading="1. Who we are">
          <p>MyPayAlert ("we", "us", "our") provides tools that help workers track pay, overtime, premiums and future paycheck estimates. This policy applies to the MyPayAlert website and application at mypayalert.com.</p>
        </Section>

        <Section heading="2. Information we collect">
          <p>We collect only what we need to run the service:</p>
          <ul className="list-disc pl-5 space-y-1.5">
            <li><span className="text-slate-300">Account information</span> — your name, email address and password (stored only as a secure hash).</li>
            <li><span className="text-slate-300">Pay and work data</span> — the shifts, hours, pay rates, premiums, deductions and pension inputs you enter to calculate your paychecks.</li>
            <li><span className="text-slate-300">Billing information</span> — if you subscribe to a paid plan, payments are processed by Stripe. We do not store your full card number; Stripe handles that.</li>
            <li><span className="text-slate-300">Usage data</span> — basic analytics (pages viewed, features used) to improve the product.</li>
          </ul>
        </Section>

        <Section heading="3. How we use your information">
          <ul className="list-disc pl-5 space-y-1.5">
            <li>To calculate your pay estimates, projections and reports.</li>
            <li>To provide, secure and improve the service.</li>
            <li>To process subscription payments and send service-related emails.</li>
            <li>To respond to your support requests.</li>
          </ul>
          <p>We do <span className="text-slate-300">not</span> sell your personal information.</p>
        </Section>

        <Section heading="4. Sharing your information">
          <p>We share data only with service providers that help us operate MyPayAlert — for example Stripe (payments) and our email provider — and only to the extent needed. These providers are bound by their own privacy and security obligations. We may also disclose information if required by law.</p>
        </Section>

        <Section heading="5. Data security">
          <p>Passwords are hashed, connections are encrypted in transit, and access to your data is restricted. No system is perfectly secure, but we take reasonable measures to protect your information.</p>
        </Section>

        <Section heading="6. Your choices and rights">
          <p>You can view and edit your data in the app at any time, and you can request deletion of your account and associated data by contacting us. Depending on where you live, you may have additional rights to access, correct, or delete your personal information.</p>
        </Section>

        <Section heading="7. Data retention">
          <p>We keep your data for as long as your account is active. If you delete your account, we remove your personal data within a reasonable period, except where we must retain records to meet legal or accounting obligations.</p>
        </Section>

        <Section heading="8. Children">
          <p>MyPayAlert is intended for working adults and is not directed at children under 16.</p>
        </Section>

        <Section heading="9. Changes to this policy">
          <p>We may update this policy from time to time. Material changes will be posted on this page with a new "last updated" date.</p>
        </Section>

        <Section heading="10. Contact us">
          <p>Questions about your privacy? Email us at <a href={`mailto:${SUPPORT_EMAIL}`} className="text-blue-400 hover:text-blue-300" data-testid="privacy-email">{SUPPORT_EMAIL}</a>.</p>
        </Section>
      </div>
    </LegalShell>
  );
}
